const EDUCATION_SCREENS: Record<string, string> = {
  "/": "landing",
  "/20m": "coming_soon",
  "/signup": "signup",
  "/login": "login",
  "/home": "home",
};

export interface ResolvedScreen {
  screen: string;
  pagePath: string;
}

export function screenForPath(pathname: string): ResolvedScreen | null {
  const screen = EDUCATION_SCREENS[pathname];
  if (!screen) return null;
  return { screen, pagePath: pathname };
}
